
<template>
  <a class="app-link" :class="{ loading }" href="#" @click.prevent="onClick" :title="title">
    <span v-show="loading" class="pad-right-half"><b-spinner small /></span>
    <app-icon v-if="icon" :icon="icon" /> <slot />
  </a>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import AppIcon from "../app-icon/app-icon.vue";
import { BaseComponent } from "../base-component/base-component";

@Component({
  name: "app-link",
  components: {
    AppIcon,
  }
})
export default class AppLink extends BaseComponent {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: null }) icon!: string | null;
  @Prop({ default: "" }) title!: string;

  onClick() {
    if (!this.loading) {
      this.$emit("click")
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/_colors.scss";

.app-link {
  &.loading {
    color: var(--muted-text-color);
    cursor: wait;
    text-decoration: none;
  }
}
</style>